import React from "react";
import { Container, Typography, Box, Link } from "@mui/material";
import { Link as RouterLink, useHistory } from "react-router-dom";

const PrivacyPolicy = () => {
  const history = useHistory();

  const handleDeleteAccountClick = (e) => {
    e.preventDefault();
    history.push('/delete-account');
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  };

  return (
    <Container maxWidth="md" style={{ paddingTop: 80, paddingBottom: 40 }}>
      <Box>
        <Typography variant="h3" gutterBottom align="center" style={{ marginBottom: 40 }}>
          Privacy Policy
        </Typography>
        <Typography variant="body1" paragraph style={{ marginBottom: 32 }}>
          At Costing Wizard, we are committed to maintaining your privacy and protecting your personal information. This privacy policy explains how we collect, use, and protect your information.
        </Typography>
        
        <Typography variant="h5" gutterBottom style={{ marginTop: 32, marginBottom: 12 }}>1. Information Collection</Typography>
        <Typography variant="body1" paragraph style={{ marginBottom: 32 }}>
          We collect information that you provide to us directly when registering for the service: name and email address. The information is collected for internal communication within the application, providing technical support, and improving the service. Additionally, we may collect technical information about application usage, including crash data and errors for the purpose of improving system stability and fixing bugs.
        </Typography>

        <Typography variant="h5" gutterBottom style={{ marginTop: 32, marginBottom: 12 }}>2. Use of Information</Typography>
        <Typography variant="body1" paragraph style={{ marginBottom: 32 }}>
          The information we collect is used for providing the service, improving the application, providing technical support, and contacting you regarding service-related matters. We will not share your personal information with third parties without your explicit consent.
        </Typography>

        <Typography variant="h5" gutterBottom style={{ marginTop: 32, marginBottom: 12 }}>3. Information Security</Typography>
        <Typography variant="body1" paragraph style={{ marginBottom: 32 }}>
          We employ technical and organizational security measures to protect your information. Information is encrypted in transit between your device and our servers. Data is stored on Firebase servers which provide security measures according to Google's security standards. However, no method of internet transmission or storage is 100% secure.
        </Typography>

        <Typography variant="h5" gutterBottom style={{ marginTop: 32, marginBottom: 12 }}>4. Cookies</Typography>
        <Typography variant="body1" paragraph style={{ marginBottom: 32 }}>
          The website uses cookies to improve user experience, remember preferences, and provide personalized service. You can manage cookie settings through your browser.
        </Typography>

        <Typography variant="h5" gutterBottom style={{ marginTop: 32, marginBottom: 12 }}>5. User Rights</Typography>
        <Typography variant="body1" paragraph style={{ marginBottom: 32 }}>
          You have the right to view the personal information stored about you, request its correction or deletion, and limit its processing. To exercise these rights or for any privacy-related questions, you can contact us. If you wish to delete your account and all associated data, please visit our <Link component={RouterLink} to="/delete-account" onClick={handleDeleteAccountClick} color="primary">Account Deletion</Link> page for instructions.
        </Typography>

        <Typography variant="h5" gutterBottom style={{ marginTop: 32, marginBottom: 12 }}>6. Policy Changes</Typography>
        <Typography variant="body1" paragraph style={{ marginBottom: 32 }}>
          We may update this privacy policy from time to time. In case of material changes, we will notify you. Continued use of the service after publication of changes will be considered consent to the updated policy.
        </Typography>

        <Typography variant="h5" gutterBottom style={{ marginTop: 32, marginBottom: 12 }}>7. Contact</Typography>
        <Typography variant="body1" paragraph style={{ marginBottom: 32 }}>
          For any questions or clarifications regarding the privacy policy, you can contact us at: support@costingwizard.com or through the contact form on the website.
        </Typography>

        <Typography variant="body2" color="textSecondary" align="center" style={{ marginTop: 48 }}>
          Last updated: May 2025
        </Typography>
      </Box>
    </Container>
  );
};

export default PrivacyPolicy; 